import { useConfirmDialog } from '@if/mui'
import { useTranslation } from 'react-i18next'

export interface AptPayDetailsProps {
  paymentCount: number
}

export const useAptPayDetailsDialog = () => {
  const { t } = useTranslation()
  return useConfirmDialog<AptPayDetailsProps>({
    title: t('disburse.aptPay.title'),
    message: (ctx) => t('disburse.aptPay.subtitle', { count: ctx.props.paymentCount }),
  })
}
